import React from 'react';
import { StepProps } from '../MultiStepModal';

const TYPE_LABELS: Record<string, string> = {
  INDIVIDUAL: 'Individual',
  BUSINESS: 'Business',
  LANDLORD: 'Landlord',
  LETTING_AGENT: 'Letting agent',
};

function fmt(value: any, fallback = '—') {
  const v = typeof value === 'string' ? value.trim() : value;
  return v ? String(v) : fallback;
}

export default function ClientReviewStep({ data }: StepProps) {
  const clientType = (data.clientType as string) || 'INDIVIDUAL';
  const isBusiness = clientType === 'BUSINESS' || clientType === 'LETTING_AGENT';
  const billingEmail = data.billingSameAsPrimary !== false ? data.customerEmail : data.billingEmail;

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Review & create</h3>
        <p className="step-form-subtitle">
          Double-check the details below. You can edit anything by going back.
        </p>
      </div>

      <div className="ui-wizard-review">
        <div className="ui-wizard-review-card">
          <div className="ui-wizard-review-header">
            <h4 className="ui-wizard-review-title">Identity</h4>
          </div>
          <div className="ui-wizard-review-body">
            <dl className="ui-wizard-review-dl">
              <dt>Type</dt>
              <dd>{TYPE_LABELS[clientType] || clientType}</dd>
              <dt>Name</dt>
              <dd>{fmt(data.customerName)}</dd>
              {isBusiness && (
                <>
                  <dt>Company</dt>
                  <dd>{fmt(data.companyName)}</dd>
                </>
              )}
            </dl>
          </div>
        </div>

        <div className="ui-wizard-review-card">
          <div className="ui-wizard-review-header">
            <h4 className="ui-wizard-review-title">Contact</h4>
          </div>
          <div className="ui-wizard-review-body">
            <dl className="ui-wizard-review-dl">
              <dt>Phone</dt>
              <dd>{fmt(data.customerPhone)}</dd>
              <dt>Email</dt>
              <dd>{fmt(data.customerEmail)}</dd>
              <dt>Billing email</dt>
              <dd>{fmt(billingEmail)}</dd>
            </dl>
          </div>
        </div>

        <div className="ui-wizard-review-card">
          <div className="ui-wizard-review-header">
            <h4 className="ui-wizard-review-title">Address</h4>
          </div>
          <div className="ui-wizard-review-body">
            <dl className="ui-wizard-review-dl">
              <dt>Line 1</dt>
              <dd>{fmt(data.customerAddress)}</dd>
              {data.addressLine2 && (
                <>
                  <dt>Line 2</dt>
                  <dd>{fmt(data.addressLine2)}</dd>
                </>
              )}
              <dt>City</dt>
              <dd>{fmt(data.city)}</dd>
              <dt>Postcode</dt>
              <dd>{fmt(data.postcode)}</dd>
              <dt>Country</dt>
              <dd>{fmt(data.country, 'United Kingdom')}</dd>
            </dl>
          </div>
        </div>

        {(data.notes || data.marketingOptIn) && (
          <div className="ui-wizard-review-card">
            <div className="ui-wizard-review-header">
              <h4 className="ui-wizard-review-title">Other</h4>
            </div>
            <div className="ui-wizard-review-body">
              <dl className="ui-wizard-review-dl">
                {data.notes && (
                  <>
                    <dt>Notes</dt>
                    <dd>{data.notes}</dd>
                  </>
                )}
                <dt>Marketing opt-in</dt>
                <dd>{data.marketingOptIn ? 'Yes' : 'No'}</dd>
              </dl>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
